export default __webpack_public_path__ + "static/spiritual-maya-hotel-4-a81a3267b6a60a991daf6a4d72aa0997.jpg";